import { FC } from 'react';
import * as Styled from './CustomFooter.styled';

type CustomFooterProps = {
  // can customise the bg and text color with this
  className?: string;
};

const CustomFooter: FC<CustomFooterProps> = ({ className, children }) => {
  return (
    <Styled.FooterWrapper className={className}>
      <Styled.FooterInner>{children}</Styled.FooterInner>
    </Styled.FooterWrapper>
  );
};

export default CustomFooter;
